<footer class="app-footer" role="contentinfo" aria-label="Application Footer">
    <div class="app-footer__logos">
        <img src="assets/images/absa-logo.png" alt="Logo 1" class="app-footer__logo" />
        <img src="assets/images/sf_logo.png" alt="Logo 2" class="app-footer__logo" />
    </div>
    <p class="app-footer__text">
        <a href="https://www.smartfunder.co.za/privacy" target="_blank" rel="noopener noreferrer">Privacy policy</a>
    </p>
    <p class="app-footer__text">
        Absa Bank Limited, Registration number 1986/004794/06. All rights reserved |
        <a href="https://www.absa.co.za/about-us/absa-bank/corporate-information/" target="_blank" rel="noopener noreferrer" >
             Authorised Financial Services Provider and a registered credit provider (NCRCP7)
        </a>
    </p>
</footer>